'use es6';

import { POSTAL_MAIL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const PostalMail = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated('CRM:ILSFilters:ActivityFilters'),
  objectTypeId: POSTAL_MAIL_TYPE_ID,
  referenceObjectType: 'POSTAL_MAIL_PROPERTIES'
});
export default PostalMail;